import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TopBanner, Nav, Footer, SUPPORT_EMAIL, APP_NAME } from './SiteChrome';
import './site.css';

export default function Privacy() {
  useEffect(() => { document.title = 'Privacy Policy — SparkSync'; }, []);
  return (
    <div className="site">
      <TopBanner />
      <Nav />
      <div className="wrap legal">
        <h1>Privacy <span className="grad-text">Policy</span></h1>
        <p className="updated">Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

        <p>
          {APP_NAME} (“we”, “us”, “our”) operates the {APP_NAME} mobile application and website (the
          “Service”). This Privacy Policy explains what information we collect, how we use it, and the
          choices you have. By using the Service you agree to this policy.
        </p>

        <h2>1. Information we collect</h2>
        <ul>
          <li><b>Account information:</b> phone number or email (used for OTP login), name, date of birth, gender.</li>
          <li><b>Profile information:</b> photos, bio, interests, profession, height, and preferences you choose to share.</li>
          <li><b>Location:</b> approximate location to show nearby matches (you can control this in your device settings).</li>
          <li><b>Usage data:</b> swipes, matches, messages, and interactions to operate and improve the Service.</li>
          <li><b>Device data:</b> app version, device type and diagnostics for reliability and security.</li>
        </ul>

        <h2>2. How we use your information</h2>
        <ul>
          <li>To create your account and show you relevant matches based on your filters.</li>
          <li>To enable chat, audio/video calls, matching and other core features.</li>
          <li>To verify accounts, prevent fraud, and keep the community safe.</li>
          <li>To process membership purchases (via our payment provider) and provide support.</li>
          <li>To send you important notifications about your account and activity.</li>
        </ul>

        <h2>3. Sharing of information</h2>
        <p>
          We do not sell your personal data. Your profile is shown to other users as part of the matching
          experience. We share limited data with trusted service providers (e.g. cloud hosting, image
          storage, and payment processing such as Razorpay) only to operate the Service, and when required
          by law.
        </p>

        <h2>4. Payments</h2>
        <p>
          Membership payments are processed by our payment gateway. We do not store your full card details;
          those are handled securely by the payment provider.
        </p>

        <h2>5. Data retention & deletion</h2>
        <p>
          We keep your information while your account is active. You can request deletion of your account
          and associated data at any time from the <Link to="/delete-account" className="grad-text">Delete Account</Link>{' '}
          page or by emailing us. We remove your profile and personal data, except where we must retain
          certain records to comply with legal obligations.
        </p>

        <h2>6. Security</h2>
        <p>
          We use industry-standard measures (encryption in transit, access controls) to protect your data.
          No method of transmission or storage is 100% secure, but we work hard to safeguard your information.
        </p>

        <h2>7. Children</h2>
        <p>{APP_NAME} is strictly for users aged 18 and older. We do not knowingly collect data from anyone under 18.</p>

        <h2>8. Your rights</h2>
        <p>
          You may access, update, or delete your information at any time within the app, or by contacting us.
          You can also disable location and notifications from your device settings.
        </p>

        <h2>9. Changes to this policy</h2>
        <p>We may update this policy from time to time. Material changes will be reflected on this page with a new date.</p>

        <h2>10. Contact us</h2>
        <p>Questions about privacy? Email us at <a className="grad-text" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.</p>
      </div>
      <Footer />
    </div>
  );
}
